import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        questions: '=',
        comparisonQuestions: '=',
        questionCounter: '=',
        comparisonQuestionCounter: '=',
        title: '=',
        compareTitle: '=',
        showIndividualAnswers: '='
    },
    template: `
    <div class="items09">
        <div class="item" ng-repeat="question in vm.questions">
            <survey-public-report-question-radio
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.RADIO"
                question="question"
                counter="vm.questionCounter[question.id]"
                compare-counter="vm.comparisonQuestionCounter[question.id]"
                compare-question="vm.getCompareQuestion(question.id)"
                title="vm.title"
                compare-title="vm.compareTitle"
            />
            <survey-public-report-question-text
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT"
                question="question"
                counter="vm.questionCounter[question.id]"
                compare-counter="vm.comparisonQuestionCounter[question.id]"
                compare-question="vm.getCompareQuestion(question.id)"
                title="vm.title"
                compare-title="vm.compareTitle"
            />
            <survey-public-report-question-scale
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.SCALE"
                question="question"
                counter="vm.questionCounter[question.id]"
                compare-counter="vm.comparisonQuestionCounter[question.id]"
                compare-question="vm.getCompareQuestion(question.id)"
                title="vm.title"
                compare-title="vm.compareTitle"
                show-individual-answers="vm.showIndividualAnswers"
            />
            <survey-public-report-question-matrix
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.MATRIX"
                question="question"
                counter="vm.questionCounter[question.id]"
                compare-counter="vm.comparisonQuestionCounter[question.id]"
                compare-question="vm.getCompareQuestion(question.id)"
                title="vm.title"
                compare-title="vm.compareTitle"
            />
            <survey-public-report-question-checkbox
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX"
                question="question"
                counter="vm.questionCounter[question.id]"
                compare-counter="vm.comparisonQuestionCounter[question.id]"
                compare-question="vm.getCompareQuestion(question.id)"
                title="vm.title"
                compare-title="vm.compareTitle"
            />
        </div>
    </div>
    `
})
export default class {
    constructor (QUESTIONS_TYPE_ENUM, lodash) {
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.lodash = lodash;
    }

    getCompareQuestion (id) {
        if (!this.comparisonQuestions) {
            return 0;
        }
        return this.lodash.find(this.comparisonQuestions, { id });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/report/results/index.js